export const leftLabelFormat = (label, numChars) => {
    return label.length > numChars ? label.substr(0, numChars) + '...' : label;
}

export const rightLabelFormat = (label, numChars) => {
    const len = label.length;
    return '...' + label.substr(len-numChars, numChars);
}

export function generateColorShades(baseHue = 210, count = 5) {
    const saturation = 100;
    const midLight = 60;
    const step = 30 / count;
  
    return Array.from({ length: count }, (_, i) => {
      const l = Math.max(0, Math.min(100, midLight + (i - Math.floor(count / 2)) * step));
      return `hsl(${baseHue}, ${saturation}%, ${l}%)`;
    });
  }